import arrowImg from "../../../../../picture/PlayLanguage.png";

const CustomNumInput = ({ selectedValue, min = 30, max = 60, label, onChange }) => {
  const current = selectedValue !== "" && selectedValue !== undefined && selectedValue !== null
    ? Number(selectedValue)
    : null;

  const handleClickNext = () => {
    const next = current === null ? min : current + 1;
    if (next > max) return;
    onChange(next);
  };

  const handleClickPrev = () => {
    const prev = current === null ? min : current - 1;
    if (prev < min) return;
    onChange(prev);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type="number"
        value={current ?? ""}
        readOnly
        placeholder={label}
        style={{
          width: "100%",
          fontSize: "16px",
          height: "40px",
          padding: "10px",
        }}
      />
      <div
        style={{
          width: "30px",
          position: "absolute",
          right: "0px",
          top: "5px",
          flexDirection: "column",
          display: "flex",
          gap: "3px",
        }}
      >
        <img
          src={arrowImg}
          alt=""
          className="profile-select-item-img"
          style={{ transform: "rotate(-90deg)", cursor: "pointer" }}
          onClick={handleClickNext}
        />
        <img
          src={arrowImg}
          alt=""
          className="profile-select-item-img"
          style={{ transform: "rotate(90deg)", cursor: "pointer" }}
          onClick={handleClickPrev}
        />
      </div>
    </div>
  );
};

export default CustomNumInput;